var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7444_13604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5237 19.5669C29.4196 28.0066 20.8717 33.1428 12.431 31.0382C3.99387 28.9341 -1.14238 20.3856 0.962723 11.9465C3.06586 3.50587 11.6138 -1.63086 20.052 0.473263C28.4921 2.57739 33.6278 11.1268 31.5237 19.5669Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1889 13.5116C23.5025 11.4153 21.9065 10.2884 19.7241 9.53666L20.432 6.69703L18.7035 6.26626L18.0143 9.03106C17.5599 8.91783 17.0932 8.811 16.6294 8.70516L17.3236 5.92213L15.5961 5.49136L14.8877 8.33001C14.5115 8.24434 14.1423 8.15968 13.7839 8.07057L13.7859 8.06171L11.4021 7.4665L10.9423 9.31265C10.9423 9.31265 12.2248 9.60656 12.1977 9.62478C12.8977 9.79955 13.0243 10.2628 13.0031 10.6301L12.1967 13.865C12.2449 13.8773 12.3075 13.8951 12.3764 13.9226C12.3188 13.9084 12.2573 13.8926 12.1938 13.8773L11.0634 18.409C10.9777 18.6217 10.7606 18.9407 10.2713 18.8196C10.2885 18.8447 9.01492 18.506 9.01492 18.506L8.15682 20.4846L10.4062 21.0453C10.8246 21.1502 11.2347 21.26 11.6384 21.3634L10.9231 24.2355L12.6496 24.6663L13.3581 21.8247C13.8297 21.9527 14.2875 22.0708 14.7355 22.1821L14.0296 25.0104L15.7581 25.4412L16.4734 22.5744C19.4208 23.1322 21.6372 22.9072 22.5701 20.2414C23.3219 18.0949 22.5327 16.8568 20.9819 16.0494C22.1113 15.789 22.962 15.0461 23.1889 13.5116ZM19.2396 19.0495C18.7055 21.196 15.0915 20.0356 13.9198 19.7447L14.8689 15.9396C16.0406 16.232 19.7979 16.811 19.2396 19.0495ZM19.7743 13.4805C19.2869 15.433 16.2789 14.441 15.3032 14.1978L16.1637 10.7468C17.1395 10.99 20.2819 11.4439 19.7743 13.4805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7444_13604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.35bb8aacca6530f25b78e12f69f13db9.svg";
export { ForwardRef as ReactComponent };